import { Driver } from 'neo4j-driver';
import {
  Neo4jConfig,
  NeovisConfig,
  Node,
  Edge,
  LabelConfig,
  RelationshipConfig,
} from 'neovis.js';
import { EdgeOptions, NodeOptions } from 'vis-network';

export class NeoVisConfigSingleton {
  private static instance: NeoVisConfigSingleton;
  private nodes: NodeOptions = null;
  private edges: EdgeOptions = null;
  private labels: { [key: string]: LabelConfig } = {};
  private relationships: { [key: string]: RelationshipConfig } = {};
  private initialCypher: string = '';
  private neo4jConfig: Neo4jConfig | Driver = null;
  public consoleDebug = true;

  constructor() {}

  public static getInstance(): NeoVisConfigSingleton {
    if (!NeoVisConfigSingleton.instance) {
      NeoVisConfigSingleton.instance = new NeoVisConfigSingleton();
    }
    return NeoVisConfigSingleton.instance;
  }

  public addNodeConfig(node: NodeOptions) {
    this.nodes = node;
  }

  public addEdgeConfig(edge: EdgeOptions) {
    this.edges = edge;
  }

  public setNeo4jConfig(config: Neo4jConfig) {
    this.neo4jConfig = {
      serverUrl: config.serverUrl,
      serverUser: config.serverUser,
      serverPassword: config.serverPassword,
    };
  }

  public addLabels(labelsToAdd: { [key: string]: LabelConfig }) {
    Object.keys(labelsToAdd).forEach((key) => {
      this.labels[key] = labelsToAdd[key];
    });
  }

  public addRelationships(relationshipsToAdd: {
    [key: string]: RelationshipConfig;
  }) {
    Object.keys(relationshipsToAdd).forEach((key) => {
      this.relationships[key] = relationshipsToAdd[key];
    });
  }

  public setInitialCypher(cypher: string) {
    this.initialCypher = cypher;
  }

  public getConfig(): NeovisConfig {
    console.log(this.initialCypher);

    return {
      containerId: 'vis-chart',
      neo4j: this.neo4jConfig as Neo4jConfig,
      visConfig: {
        nodes: this.nodes,
        edges: this.edges,
      },
      labels: this.labels,
      relationships: this.relationships,
      initialCypher: this.initialCypher,
      consoleDebug: this.consoleDebug,
    };
  }
}
